/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_SubjectInputs */

const en_wb_sales_subject = /** @type {(inputs: Wb_Sales_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject: Re: Connecting our sales process`)
};

const lv_wb_sales_subject = /** @type {(inputs: Wb_Sales_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temats: Re: Mūsu pārdošanas procesa savienošana`)
};

/**
* | output |
* | --- |
* | "Subject: Re: Connecting our sales process" |
*
* @param {Wb_Sales_SubjectInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_subject = /** @type {((inputs?: Wb_Sales_SubjectInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_SubjectInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_subject(inputs)
	return en_wb_sales_subject(inputs)
});